<div class="flex flex-col">
  <ng-container #menuContainer />
</div>
